import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                { name: 'Layouts', route: 'layouts' },
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
            ],
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'Staff',
            children: [
                { name: 'Staff Members', type: 'staff_member', route: 'staff_members' },
                { name: 'Departments', type: 'department', route: 'departments' },
            ],
            iconComponent: FeatherIcons.UsersIcon,
            group: 'company',
        },
        {

            name: 'Blog',
            children: [
                { name: 'Posts', route: 'news_posts', type: 'news_post' },
                { name: 'Categories', route: 'news_categories', type: 'news_category' },
            ],
            group: 'company',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                { name: 'Categories', route: 'categories', type: 'category' },
                { name: 'Locations', route: 'locations', type: 'location' },
            ],
            iconComponent: FeatherIcons.PackageIcon,
            group: 'Products',
        },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
                { name: 'Downloads', route: 'downloads', type: 'download' },
            ],
            iconComponent: FeatherIcons.MessageSquareIcon,
            group: 'client',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            iconComponent: FeatherIcons.UsersIcon,
            group: 'settings',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
